import { CategoryId } from '$/epg/categories'
import { epgChannelsModel } from '$/epg/channels'
import { attach, createEvent, sample } from 'effector'
import { LOAD_MORE_COUNT } from './index.h'

// load more channels by category id
export const load = createEvent<{ categoryId: number }>()

// load more channels list effect
export const loadMoreChannelsFx = attach({
  mapParams: ({ categoryId, page }: { categoryId: number; page: number }) => ({
    'byCategoryId': categoryId,
    'categoryId': categoryId === CategoryId.Favorite ? undefined : categoryId,
    'only-favorites': categoryId === CategoryId.Favorite ? true : undefined,
    'page': page,
    'count': LOAD_MORE_COUNT,
  }),
  effect: epgChannelsModel.loadPageFx,
})

// load more channels
// it takes currently loaded channels for category count, calculates page number to load and loads next page
sample({
  clock: load,
  source: {
    loaded: epgChannelsModel.$byCategory,
    pending: epgChannelsModel.loadPageFx.pending,
  },
  filter: ({ loaded: [_, meta], pending }, { categoryId }) =>
    pending ? false : Boolean(meta.get(categoryId)?.hasMore),
  fn: ({ loaded: [channels] }, { categoryId }) => {
    const loaded = channels.get(categoryId) ?? []
    return {
      categoryId,
      page: Math.floor(loaded.length / LOAD_MORE_COUNT),
    }
  },
  target: loadMoreChannelsFx,
})
